import { useSettings } from "hooks/useStore";
import { navigate } from "gatsby";
import { useMediaQuery } from "react-responsive";
import { SCREEN_SIZES } from "utils/constants";

const usePostATCAction = () => {
	const { toggleCart, isCartOpen } = useSettings(["toggleCart", "isCartOpen"]);
	const isMobile = useMediaQuery({ maxWidth: SCREEN_SIZES.sm });

	return () => {
		if (isMobile && !isCartOpen) {
			toggleCart();
		}

		else if (!isMobile) {
			navigate("/cart");
		}
	};
};

export default usePostATCAction;
